// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface ISimOperatorInfo {
	MCC: string | undefined;

	MNC: string | undefined;

	PLMN: string | undefined;

	region: string | undefined;

	country: string | undefined;

	ISO: string | undefined;

	operator: string | undefined;

	brand: string | undefined;

	TADIG: string | undefined;

	bands: string | undefined;

	$type?: string | undefined;
}
export class SimOperatorInfo {
	constructor(data?: ISimOperatorInfo) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	MCC: string | undefined;

	MNC: string | undefined;

	PLMN: string | undefined;

	region: string | undefined;

	country: string | undefined;

	ISO: string | undefined;

	operator: string | undefined;

	brand: string | undefined;

	TADIG: string | undefined;

	bands: string | undefined;

	static $type: string = "CoreApi.Controllers.SimOperatorInfo, ";
	$type?: string | undefined = SimOperatorInfo.$type;
}

